import React, { useEffect, useState } from 'react';
import { subscriptionAPI } from '../utils/api';
import { useNavigate } from 'react-router-dom';

const TrialTimer = () => {
    const [trialStatus, setTrialStatus] = useState(null);
    const [timeLeft, setTimeLeft] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const status = await subscriptionAPI.getTrialStatus();
                setTrialStatus(status);
                if (status.isExpired) {
                    // navigate('/subscription'); // REMOVED: Do not auto-redirect
                }
            } catch (error) {
                console.error('Failed to fetch trial status:', error);
            }
        };

        fetchStatus();
        // Refresh status every check? Or just setup internal timer?
        // Let's set up internal timer based on trialEndDate to avoid spamming API
    }, [navigate]);

    useEffect(() => {
        if (!trialStatus || !trialStatus.hasTrial || trialStatus.isExpired) return;

        const interval = setInterval(() => {
            const now = new Date();
            const end = new Date(trialStatus.trialEndDate);
            const diff = end - now;

            if (diff <= 0) {
                setTrialStatus(prev => ({ ...prev, isExpired: true }));
                // navigate('/subscription'); // REMOVED: Do not auto-redirect
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

            setTimeLeft(`${days}d ${hours}h ${minutes}m`);

        }, 60000); // Update every minute

        // Initial calc
        const now = new Date();
        const end = new Date(trialStatus.trialEndDate);
        const diff = end - now;
        if (diff > 0) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            setTimeLeft(`${days}d ${hours}h ${minutes}m`);
        }

        return () => clearInterval(interval);

    }, [trialStatus, navigate]);

    if (!trialStatus || !trialStatus.hasTrial || trialStatus.isExpired) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#ff9800',
            color: '#fff',
            padding: '5px 15px',
            borderRadius: '0 0 10px 10px',
            zIndex: 9999,
            fontWeight: 'bold',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
        }}>
            Free Trial: {timeLeft} remaining
        </div>
    );
};

export default TrialTimer;
